import { computed, defineComponent, ref, watch } from "vue";
import { RoomSb } from "~/extensions/utils/DefineTypes";
export default defineComponent({
    name: "TaikyoRoomPane",
    props: {
        modelValue: {
            type: Boolean,
            required: true
        },
        selected: {
            type: Array,
            default: () => []
        },
        bulkRoom: {
            type: Boolean,
            default: false
        },
        showDelete: {
            type: Boolean,
            default: false
        },
        noDataLabel: {
            type: String,
            default: "データがありません"
        }
    },
    emits: ["update:modelValue", "delete", "submit", "add"],
    setup(props, { emit }) {
        const selectedRooms = ref([]);
        const displayedRooms = ref([]);
        watch(() => props.selected, val => {
            displayedRooms.value = [...val];
        }, { immediate: true });
        const clear = () => {
            selectedRooms.value = [];
        };
        const drawerModel = computed({
            get: () => props.modelValue,
            set: val => {
                emit("update:modelValue", val);
            }
        });
        const inputValue = ref("");
        const applyFilter = () => {
            const keyword = inputValue.value.trim().toLowerCase();
            displayedRooms.value = keyword
                ? props.selected.filter(room => [room.bukkenName, room.roomNumber, room.nyukyosha].some(value => value?.toString().toLowerCase().includes(keyword)))
                : [...props.selected];
        };
        const onAdd = () => {
            emit("add", selectedRooms.value);
            clear();
            drawerModel.value = false;
        };
        return {
            drawerModel,
            RoomSb,
            selectedRooms,
            clear,
            inputValue,
            applyFilter,
            displayedRooms,
            onAdd
        };
    }
});
